module.exports = __webpack_public_path__ + "static/img/cloud2.bb59fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clouds/img/cloud2.png
// module id = 6OAD
// module chunks = 1